var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3106_25067)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.08075 0.164251C5.13309 0.112049 5.1952 0.0706735 5.26353 0.0424903C5.33187 0.0143072 5.40509 -0.000131118 5.479 8.9718e-07H13.354C13.5032 8.9718e-07 13.6463 0.0592641 13.7518 0.164753C13.8572 0.270243 13.9165 0.413317 13.9165 0.562501C13.9165 1.3275 13.5318 1.88325 13.1898 2.22638C13.048 2.367 12.9085 2.47838 12.7915 2.56163V7.5465L12.8793 7.6005C13.1076 7.74338 13.4148 7.95375 13.7241 8.22488C14.3215 8.74688 15.0415 9.59288 15.0415 10.6875C15.0415 10.8367 14.9822 10.9798 14.8768 11.0852C14.7713 11.1907 14.6282 11.25 14.479 11.25H9.979V16.3125C9.979 16.623 9.727 18 9.4165 18C9.106 18 8.854 16.623 8.854 16.3125V11.25H4.354C4.20482 11.25 4.06175 11.1907 3.95626 11.0852C3.85077 10.9798 3.7915 10.8367 3.7915 10.6875C3.7915 9.59288 4.5115 8.74688 5.10775 8.22488C5.39879 7.97216 5.71121 7.74518 6.0415 7.5465V2.56163C5.89964 2.46118 5.76642 2.34904 5.64325 2.22638C5.30125 1.88325 4.9165 1.32638 4.9165 0.562501C4.91637 0.488583 4.93081 0.415364 4.95899 0.347029C4.98718 0.278695 5.02855 0.216585 5.08075 0.164251Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3106_25067"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.416504)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinFill);
export default __webpack_public_path__ + "static/media/pin-fill.f1219455fdb850415bf32c0ffabcb625.svg";
export { ForwardRef as ReactComponent };